export const MODULE_OPTIONS = [
  { key: 'soporte_gestion', label: 'Gestionar soporte (bandeja central)' },
  { key: 'modulo_admision', label: 'Admisión (pantalla de admisiones)' },
  { key: 'admision', label: 'Alta y edición de pacientes' },
  { key: 'facturacion', label: 'Facturación' },
  { key: 'expedientes', label: 'Expedientes' },
  { key: 'informes', label: 'Informes' },
  { key: 'asistencias', label: 'Asistencias' },
  { key: 'agendas', label: 'Agendas' },
  { key: 'ficha_pacientes', label: 'Ver ficha de pacientes' },
  { key: 'ficha_pacientes_editar', label: 'Editar ficha de pacientes' },
];

export function isBillingEnabled() {
  return typeof window !== 'undefined' && window.APP_CONFIG?.BILLING_ENABLED === true;
}

export function availableModuleOptions() {
  return MODULE_OPTIONS.filter((module) => module.key !== 'soporte_gestion' && (module.key !== 'facturacion' || isBillingEnabled()));
}

const PAGE_MODULES = {
  admision: 'modulo_admision',
  facturacion: 'facturacion',
  expedientes: 'expedientes',
  reports: 'informes',
  attendances: 'asistencias',
  agendas: 'agendas',
  // Equipo Cenein usa los datos de Agendas (centros, consultorios y profesionales).
  equipo: 'agendas',
};

// Permiso puntual, por ejemplo 'admision' (alta y edición de pacientes).
export function hasModule(user, module) {
  return Boolean(user && (user.isAdmin || (Array.isArray(user.modulePermissions) && user.modulePermissions.includes(module))));
}

export function canOpenPage(user, page) {
  if (!user) return false;
  if (page === 'support') return true;
  if (page === 'facturacion' && !isBillingEnabled()) return false;
  if (user.isAdmin) return true;
  // Profesionales muestra DNI y email: solo administradores.
  if (page === 'users' || page === 'user-history' || page === 'profesionales') return false;
  const permissions = Array.isArray(user.modulePermissions) ? user.modulePermissions : [];
  if (page === 'dashboard' || page === 'patients') {
    return MODULE_OPTIONS.some(({ key }) => key !== 'soporte_gestion' && permissions.includes(key));
  }
  if (page === 'alta') return permissions.includes('admision') || permissions.includes('asistencias');
  if (page === 'patient') return permissions.includes('admision') || permissions.includes('ficha_pacientes') || permissions.includes('ficha_pacientes_editar');
  if (page === 'patient-edit') return permissions.includes('admision') || permissions.includes('ficha_pacientes_editar');
  const module = PAGE_MODULES[page];
  return Boolean(module && permissions.includes(module));
}

export function firstAllowedPage(user) {
  return ['dashboard', 'attendances', 'agendas', 'expedientes', 'facturacion', 'reports', 'support']
    .find((page) => canOpenPage(user, page)) || null;
}
